import React from 'react';
import SelectedProduct from './SelectedProduct'
import { TbPhotoX } from 'react-icons/tb';
import { cropString, isAllergen, useQuantityProductInCartConference, vibrate } from '../../../Utils/Helpers';
import ProductPrice from './ProductPrice';
import BadgeNewProduct from './BadgeNewProduct';
import BadgeProductSale from './BadgeProductSale';
import { useProductsHook } from '../../../Hooks/ProductsHook';
import { useStoreHook } from '../../../Hooks/StoreHook';
import { useLayoutContext } from '../../../Contexts/LayoutContext';
import { useAddProductContext } from '../../../Contexts/AddProductContext';
import BadgeAllergenTag from './BadgeAllergenTag';

interface CardProductGridProps {
    product: any;
    category: any;
    loading?: boolean;
}

const CardProductGrid = ({
    product,
    category,
    loading,
}: CardProductGridProps) => {

    const { setShowAddProduct, setProduct, setCategory } = useAddProductContext();
    const { hasCurrentAddress } = useProductsHook();
    const { openProductToAdd } = useStoreHook();
    const { setEnableLoadProducts } = useLayoutContext();

    const handleProduct = () => {
        if (!hasCurrentAddress(product.slug)) return;

        setShowAddProduct(true);
        setProduct(product);
        setCategory(category);

        if (product.slug) {
            setEnableLoadProducts(false);
        } else {
            openProductToAdd(product, category);
        }
        vibrate();
    }

    const quantitySelected = useQuantityProductInCartConference(product.id);

    return (
        <>
            {!loading
                ?
                    <div onClick={handleProduct} className={`relative flex flex-col w-full h-full hover:text-custom-primary cursor-pointer transition ease-in-out duration-200 ring-1
                        ring-transparent
                        hover:text-shopfood-title
                        rounded-xl
                        `}>
                        
                        {/* ALLERGEN TAG  */}
                        <BadgeAllergenTag product={product} className='absolute w-full aspect-square z-10' />

                        <div
                            className={`
                                relative flex items-center justify-center bg-cover bg-center bg-no-repeat aspect-square ring-b ring-0 ring-opacity-50 ring-gray-200 bg-gray-100 rounded-xl
                                ${isAllergen(product) ? 'opacity-50' : ''}
                            `}
                            style={{backgroundImage: `url('${product.photos?.medium}')`}}
                            >

                            {!product.photos?.thumbnail && <TbPhotoX className='text-white w-1/3 h-1/2' />}

                            {/* PRODUCT IN CART */}
                            {quantitySelected > 0 && <SelectedProduct quantity={quantitySelected} />}

                            {/* BADGE FOR NEW PRODUCT ON CATALOG */}
                            <BadgeNewProduct product={product} className='absolute left-0 bottom-0 rounded-tr-xl rounded-bl-xl' />

                            {/* PRODUCT SALE  */}
                            <BadgeProductSale product={product} className='absolute left-0 bottom-0 rounded-tr-xl rounded-bl-xl' />

                        </div>
                        <div className={`flex flex-col justify-between gap-1.5 h-full py-2.5 px-1 pt-1.5 md:p-4 ${isAllergen(product) ? 'opacity-50' : ''}`}>
                            <h3 className="text-shopfood-title font-medium text-sm lg:text-md ">{ cropString(product.name, 35)}</h3>
                            <h4 className="font-medium text-sm text-gray-500 leading-4">
                                <ProductPrice product={product} classNameFromPriceText='text-xs font-normal text-gray-400' />
                            </h4>
                        </div>
                    </div>
                :
                    <div className="flex gap-4 w-full rounded-xl animate-pulse mb-2">
                        <div className="flex gap-4 w-full h-full rounded-lg animate-pulse">
                            <div className="flex flex-col justify-between flex-grow gap-2">
                                <div className="bg-gray-200 aspect-square rounded-xl"></div>
                                <div className="flex flex-col gap-1 px-1 justify-between h-full w-full">
                                    <div className="bg-gray-200 w-4/5 h-2 rounded"></div>
                                    <div className="bg-gray-200 w-2/5 h-2 rounded"></div>
                                    <div className="bg-gray-200 w-1/5 h-2 rounded"></div>
                                </div>
                            </div>
                        </div>
                    </div>
            }
        </>
    );
};

export default CardProductGrid;
